module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "FOREWORD"
    }
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "fore"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rfore"
    }
  }, [_c('b', [_vm._v("FOREWORD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v(" few years ago my professional bio simply read: “attorney,” “diplomat,” and “nonprofit founder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reading it sort of made me want to take a nap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So when I’d meet new acquaintances, and I’d crack a joke or notice something completely absurd, they’d often glance past me in search of the real grown-up. That’s why, for the sake of transparency, I changed the bio to say: “Chief of Fun & Whimsy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It felt more honest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you were to ask the people who know me best in this world what my "), _c('i', [_vm._v("one thing")]), _vm._v(" is—what wakes me up every morning, propels me through the day, and rattles around in my head at night before I fall asleep—most of them would say "), _c('i', [_vm._v("love")]), _vm._v(". It’s my thing. It really is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s what I was made for, and it’s what you were made for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But if you’d only known me a few minutes, if you were that handshaker—shaking your head and wondering what sort of shenanigans would unfold should I be allowed "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("to speak in a court of law—you might also make the reasonable guess that my thing, my "), _c('i', [_vm._v("one")]), _vm._v(" thing, was "), _c('i', [_vm._v("fun")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And you wouldn’t be entirely wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t really like to draw hard and fast lines between love and fun. In my life, and in my family’s life, the two are often tangled up together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before my wife Maria and I got married, we discussed what our future might look like. Specifically, we began to imagine "), _c('i', [_vm._v("how")]), _vm._v(" we would live. And we decided together that we wanted joy and whimsy and fun to be central to the life we shared and to the family we were building. So when our daughter Lindsey was ten, and we saw $99 airline tickets to London, we decided I should take her to London for a tea party. As one does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another weekend I purchased a radio-controlled airplane and dragged the kids outside for our plane’s maiden voyage. As you might imagine, it was totally "), _c('i', [_vm._v("awesome")]), _vm._v("! It was awesome for all forty-five seconds before I flew that plane into a tree (which, of course, was actually also kind of cool). I wasn’t worried about Maria’s reaction to wasting the money, because . . . well . . . "), _c('i', [_vm._v("fun")]), _vm._v(". It’s one of the things we’d chosen to be about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can choose fun too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can choose it for yourself, and if you’ve got a family of folks who are willing to play along, you can choose it with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deciding to embrace fun is what Mandy Arioto has done, and it’s what she can help you do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("One of many things I love about Mandy is that she has chosen to be about what matters most (and by that, of course, I mean fun. Obviously. And love). She’s been intentional about both of those priorities because there was a moment in her life when she recognized a joy deficit. She noticed that she was only allowing herself to have fun after the things on her to-do list were complete. That she’d been prioritizing productivity over delight. And, in that moment, pausing to look forward and imagine the rest of her days on this earth, she considered whether she needed a new trajectory.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Do I want to check a lot of tasks off of lists, or do I want to celebrate the wonderful life I’ve been given and invite others to embrace joy along the way?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So Mandy did something similar to what sweet Maria and I had done years earlier: she committed to living the rest of her days prioritizing fun, love, and legacy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mandy has written "), _c('i', [_vm._v("Have More Fun")]), _vm._v(" for you because she is convinced that fun matters. And she’s persuaded that, in ways that can’t quite be quantified, tiny moments reshape people’s hearts. Including yours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re game, fun can change your life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It can change the lives of the people you love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And it can change the lives of people you’ve not yet met, but who you were made to love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Does that opportunity make you as amped as it makes me?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mandy is inviting you to kick off your shoes, ignore "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("whatever your law-abiding neighbors might think about you, and join her on this journey.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Say yes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your neighbors need you to say yes. Your family needs you to say yes. The world needs you to say yes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And know that as you choose to live with joy and delight and whimsy and fun, I’m cheering you on.")]), _vm._v(" "), _c('p', {
    staticClass: "rightt"
  }, [_c('i', [_vm._v("Bob Goff")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-060ddd25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310340454_Foreword.vue
// module id = 75
// module chunks = 0